var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.132,
    height: 26.126,
    viewBox: "0 0 26.132 26.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M27.448,24.351l9.334-9.334a2.187,2.187,0,0,0-3.093-3.093l-9.334,9.334-9.334-9.334a2.187,2.187,0,1,0-3.093,3.093l9.334,9.334-9.334,9.334a2.187,2.187,0,1,0,3.093,3.093l9.334-9.334,9.334,9.334a2.187,2.187,0,0,0,3.093-3.093Z",
    transform: "translate(-11.285 -11.289)",
    fill: "#888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.5485b2b5489a04d02d6bfd4ab16f7b56.svg";
export { ForwardRef as ReactComponent };